import CommonDialog from 'components/common/CommonDialog';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { jbColors } from 'theme/jbColors';
import { Box, Button } from '@mui/material';
import { sendRedistributeDocuments } from 'thunks/productDocumentsThunk';
import AddDocument from 'assets/icons/add-document-icon.svg?react';
import CloseIcon from 'assets/icons/close-icon.svg?react';

export interface DocumentRedistributionModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  documentUid?: string;
}

export function DocumentRedistributionModal(props: DocumentRedistributionModalProps) {
  const { isOpen, setIsOpen, documentUid } = props;

  const dispatch = useDispatch<AppDispatch>();

  const selectedServiceAgreement = useSelector((state: RootState) => state.serviceAgreements.selectedServiceAgreement);

  const brUidfromStore = useSelector((state: RootState) => state.account.brUid);

  const handleSubmit = async () => {
    if (documentUid) {
      dispatch(sendRedistributeDocuments([documentUid], brUidfromStore));
    }
  };

  const setContent = (serviceAgreementStatus?: string) => {
    if (serviceAgreementStatus === 'Active') {
      return 'Please confirm you would like to proceed with re-distribution of the documents. Please note that the previously distributed documents will be automatically set to expired after the validation process of the newly distributed one will be completed';
    }

    if (serviceAgreementStatus !== 'Active') {
      return 'Please confirm that the previously distributed document version will be automatically expired within the submission of the re-distribution request';
    }
  };

  return (
    <CommonDialog
      isOpen={isOpen}
      sx={{ maxWidth: '60em' }}
      onClose={() => setIsOpen(false)}
      title={'Redistribution'}
      titleIcon={<AddDocument />}
      closeIcon={<CloseIcon style={{ fill: jbColors.core.reflexBlue[100] }} onClick={() => setIsOpen(false)} />}
      removeCancel={true}
      content={
        <>
          {setContent(selectedServiceAgreement?.agreementStatus)}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              onClick={() => setIsOpen(false)}
              sx={{
                color: jbColors.core.reflexBlue[100],
                backgroundColor: 'white',
                border: `1px solid ${jbColors.core.reflexBlue[100]}`,
                '&:hover': {
                  backgroundColor: jbColors.core.reflexBlue[100],
                  color: 'white',
                },
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Confirm to proceed
            </Button>
          </Box>
        </>
      }
    />
  );
}
